export default class Validator {
	public static isValidEmail(email: string): boolean {
		// tslint:disable-next-line:max-line-length
		return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(
			email
		);
	}

	public static isValidPasswordLength(password: string): boolean {
		return password.length >= 8;
	}

	public static hasLettersAndNumbers(password: string): boolean {
		const hasCharacter: boolean = /.*[a-zA-Z]+.*/g.test(password);
		const hasNumber: boolean = /.*[0-9]+.*/g.test(password);
		const hasSpecialCharacter: boolean = /.*[^a-zA-Z0-9\s]+.*/g.test(password);

		return hasCharacter && (hasNumber || hasSpecialCharacter);
	}

	public static isNotPartOfEmail(email: string, password: string): boolean {
		const frontEmailPart: string = email.split('@')[0];

		return (
			password.length > 0 && (frontEmailPart === '' || password.indexOf(frontEmailPart) < 0)
		);
	}

	public static isInputChecked(name: string, target: HTMLFormElement): boolean {
		return target.querySelector('input[name="' + name + '"]:checked') !== null;
	}
}
